import type { ComponentTypeDefinition } from './registry';

/** A component type's palette preview, as it follows the pointer in a drag. */
export function ReportDragPreview({
  definition,
}: {
  definition: ComponentTypeDefinition;
}) {
  const Preview = definition.Preview;
  return (
    <div className="flex cursor-grabbing flex-col items-center gap-1.5 rounded-md border border-primary bg-card p-2.5 text-center shadow-xl select-none opacity-90">
      <div className="w-full">
        <Preview />
      </div>
      <span className="text-xs leading-tight">{definition.label}</span>
    </div>
  );
}
